import ReactGA from 'react-ga';

const trackingId = "G-HM3V9GXR77";
ReactGA.initialize(trackingId);

 const trackPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};
export default trackPageView
